import * as React from 'react';
import styled from 'styled-components';
import {transparentize} from 'polished';
import {ChangeEvent} from 'react';

export interface InputRangeProps {
  min: number;
  max: number;
  step: number;
  defaultValue?: number;
  onChange: (e: ChangeEvent<HTMLInputElement>) => void;
}

const Container = styled.div`
  position: relative;
  height: 8px;
  width: 100%;
  border-radius: 5px;
  background-color: ${({theme}) => transparentize(.95, theme.variables.color)};
`;

const Range = styled.input`
  width: 100%;
  height: 14px;
  position: relative;
  top: -6px;
  z-index: 5;
  -webkit-appearance: none;

  &::-webkit-slider-runnable-track {
    height: 10px;
    -webkit-appearance: none;
    color: #13bba4;
    margin-top: -1px;
  }

  &::-webkit-slider-thumb {
    width: 14px;
    -webkit-appearance: none;
    height: 14px;
    background: #fff;
    border-radius: 50%;
  }
  
`;

const Race = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  width: 0;
  box-sizing: border-box;
  border-top-left-radius: 5px;
  border-bottom-left-radius: 5px;
  background-color: ${({theme}) => theme.colors.primary};
`;

/**
 * The simple input component
 * @param {InputProps} props
 * @constructor
 */
export default function InputRange(
    props: InputRangeProps,
): React.ReactElement {
  const min = String(props.min);
  const max = String(props.max);
  const step = String(props.step);

  const [fillWidth, setFillWidth] = React.useState(
    calculatePercent(props.defaultValue || props.min),
  );

  /**
   * counts the percentage of the value from the maximum value
   * @param {number} value
   * @constructor
   */
  function calculatePercent(value: number) {
    return ((value-props.min) * 100) / (props.max - props.min);
  }

  /**
   * on change handler
   * @param {ChangeEvent<HTMLInputElement>} e
   * @constructor
   */
  function onChangeHandler(e: ChangeEvent<HTMLInputElement>) {
    const value = Number(e.target.value);
    const percent = calculatePercent(value);
    setFillWidth(percent);
    props.onChange(e);
  }

  return (
    <Container>
      <Range
        type="range"
        min={min}
        max={max}
        defaultValue={props.defaultValue || min}
        step={step}
        onChange={onChangeHandler}
      />
      <Race style={{width: `${fillWidth}%`}} />
    </Container>
  );
}
